import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./index.css";
import SinglePageAppLink from "../SinglePageAppLink";
import ReactDOM from "react-dom";
import { useBreadcrumbUpdates, useScrollTopDetector } from "../hooks";

const BrandList = ({ children }) =>
  children.map(({ title, linkUrl }) => (
    <li key={title} className={styles.brandListItem}>
      <SinglePageAppLink href={linkUrl} className={styles.brandTitle}>
        {title}
      </SinglePageAppLink>
    </li>
  ));

const GroupList = ({ items }) =>
  items.map(([key, children]) => (
    <li key={key}>
      <h2 className={styles.groupTitle} id={key}>
        {key}
      </h2>
      <ol className={styles.brandList}>
        <BrandList>{children}</BrandList>
      </ol>
    </li>
  ));

const Anchors = ({ items, hide = false }) => (
  <nav
    className={styles.anchorsContainer}
    data-hide={hide}
    aria-label="Jump to section"
  >
    {items.map(([letter]) => (
      <a className={styles.anchor} key={letter} href={`#${letter}`}>
        {letter}
      </a>
    ))}
  </nav>
);

const BrandsPage = ({ title, groups, breadcrumbs }) => {
  useBreadcrumbUpdates(breadcrumbs);
  const isAtTop = useScrollTopDetector({ offset: 300 });
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div className={styles.brandsPage}>
      <h1 className={styles.pageTitle}>{title}</h1>
      <Anchors items={groups} hide={!isAtTop} />
      {isClient &&
        ReactDOM.createPortal(
          <Anchors items={groups} hide={isAtTop} />,
          document.getElementById("chrome-sticky-header")
        )}
      <ol className={styles.groupList}>
        <GroupList items={groups} />
      </ol>
    </div>
  );
};

const groupShape = PropTypes.oneOfType([PropTypes.string, PropTypes.array]);

Anchors.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  ).isRequired,
  hide: PropTypes.bool
};

BrandsPage.propTypes = {
  title: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(groupShape).isRequired,
  breadcrumbs: PropTypes.array.isRequired
};

export default BrandsPage;
